import { Box, Checkbox, FormControl } from "@primer/react";
import { DateBox } from "devextreme-react/date-box";
import { SelectBox } from "devextreme-react/select-box";
import moment from "moment";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import TagboxHinhThucNopBom from "../../components/tagbox-hinh-thuc-nop-bom";
import Button from "../../components/ui/button";
import Modal from "../../components/ui/modal";
import ModalActions from "../../components/ui/modal/ModalActions";
import Text from "../../components/ui/text";
import TextInput from "../../components/ui/text-input";
import { sf_hinhthucmiengiam } from "../../models/response/category/sf_hinhthucmiengiam";
import { loadHinhThucMienGiamHinhThucTinhStartAction } from "../../state/actions/hinhThucMienGiamActions";
import { loadKhoanNopStart } from "../../state/actions/khoanNopActions";
import { RootState } from "../../state/reducers";
import SelectBoxNhomMienGiam from "../../components/selectbox-nhommiengiam";
import FileViewAndUpload from "../../components/file-view-and-upload";
import { IAttachment } from "../../models/response/upload/IAttachment";
import CmbHinhThucNopPhi from "../../components/combobox-hinh-thuc-nop-phi";
type HinhThucMienGiamModalProps = {
  title?: string;
  sf_hinhthucmiengiam?: sf_hinhthucmiengiam;
  onClose: () => void;
  onSubmit: (data: sf_hinhthucmiengiam) => void;
  is_saving?: boolean;
  animationOf: string;
  nam_hoc?: string;
  sf_hinhthucmiengiams?: sf_hinhthucmiengiam[];
};
const createDataObject = (
  entries: [number, number][]
): Record<number, number> => {
  return Object.fromEntries(entries);
};

const dataObject = createDataObject([
  [9, 1],
  [10, 2],
  [11, 3],
  [12, 4],
  [13, 5],
  [14, 6],
  [15, 7],
  [16, 8],
  [17, 9],
  [18, 10],
  [7, 11],
  [8, 12],
  [2, 13],
  [3, 14],
  [1, 15],
]);
const HinhThucMienGiamEditModal = (props: HinhThucMienGiamModalProps) => {
  const dispatch = useDispatch();
  const { dm_coso_id } = useSelector((x: RootState) => x.common);
  const sf_hinhthucmiengiam_hinhthuctinhs = useSelector(
    (x: RootState) => x.hinhThucMienGiam.sf_hinhthucmiengiam_hinhthuctinhs
  );
  useEffect(() => {
    if (sf_hinhthucmiengiam_hinhthuctinhs.length === 0)
      dispatch(loadHinhThucMienGiamHinhThucTinhStartAction());
  }, [dispatch, sf_hinhthucmiengiam_hinhthuctinhs.length]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<sf_hinhthucmiengiam>({
    defaultValues: props.sf_hinhthucmiengiam ?? {
      id: 0,
      hinh_thuc_mien_giam: "",
      is_active: true,
      ma_hinh_thuc: "",
      nam_hoc: props.nam_hoc || "",
      nhom_mien_giam: 1,
      sf_hinhthucmiengiam_hinhthuctinh_id: undefined,
      mien_giam_from_nhom: 1,
      so_lan_huong_toi_da: 1,
      dm_coso_id,
      sf_hinhthucnopbom_ids: "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
      DVT: "",
      tu_ngay: moment().format("YYYY-MM-DD"),
      den_ngay: moment().format("YYYY-MM-DD"),
      is_apdung_toantruong: false,
      sf_hinhthucmiengiam_group_id: undefined,
      attach_files: "",
      sf_saleset_register_type_id: 0,
    },
  });
  useEffect(() => {
    dispatch(loadKhoanNopStart());
  }, [dispatch]);
  const onSubmit = async (data: any) => {
    props.onSubmit({
      ...data,
      dm_coso_id: dm_coso_id,
    });
  };

  return (
    <Modal
      isOpen
      title={props.sf_hinhthucmiengiam ? "Cập nhật" : "Thêm mới"}
      onClose={() => {
        props.onClose();
      }}
      width={"70%"}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 3,
            mb: 2,
          }}
        >
          {/* Dòng 1: Mã + Nhóm */}

          <FormControl>
            <FormControl.Label>Nhóm miễn giảm</FormControl.Label>
            <Controller
              control={control}
              name="sf_hinhthucmiengiam_group_id"
              rules={{
                required: {
                  value: true,
                  message: "Vui lòng chọn nhóm miễn giảm",
                },
              }}
              render={({ field }) => (
                <SelectBoxNhomMienGiam
                  value={field.value}
                  isShowClearBtn={true}
                  onValueChanged={(value) => {
                    field.onChange(value);
                  }}
                  width={"100%"}
                />
              )}
            />
            {errors?.["sf_hinhthucmiengiam_group_id"] && (
              <FormControl.Validation variant="error">
                Vui lòng chọn nhóm miễn giảm
              </FormControl.Validation>
            )}
          </FormControl>
          <FormControl>
            <FormControl.Label>
              <Text text="Mã hình thức" />
            </FormControl.Label>
            <TextInput
              block
              name="ma_hinh_thuc"
              register={register}
              errors={errors}
              required
              validateMessage={`Vui lòng điền mã hình thức miễn giảm`}
            />
          </FormControl>
          {/* Dòng 2: Nội dung (full width) */}
          <FormControl sx={{ gridColumn: "1 / span 2" }}>
            <FormControl.Label>
              <Text text="Nội dung miễn giảm" />
            </FormControl.Label>
            <TextInput
              block
              name="hinh_thuc_mien_giam"
              register={register}
              errors={errors}
              required
              validateMessage={`Vui lòng điền nội dung miễn giảm`}
            />
          </FormControl>

          {/* Dòng 3: Hình thức tính + Đơn vị tính */}
          <FormControl>
            <FormControl.Label>Hình thức tính</FormControl.Label>
            <Controller
              control={control}
              name="sf_hinhthucmiengiam_hinhthuctinh_id"
              rules={{
                required: {
                  value: true,
                  message: "Vui lòng chọn hình thức tính miễn giảm",
                },
              }}
              render={({ field }) => (
                <SelectBox
                  dataSource={sf_hinhthucmiengiam_hinhthuctinhs}
                  displayExpr="hinh_thuc_tinh"
                  valueExpr="id"
                  value={field.value}
                  onValueChanged={(e) => field.onChange(e.value)}
                  width="100%"
                  height={32}
                  stylingMode="outlined"
                />
              )}
            />
            {errors?.["sf_hinhthucmiengiam_hinhthuctinh_id"] && (
              <FormControl.Validation variant="error">
                Vui lòng chọn hình thức tính miễn giảm
              </FormControl.Validation>
            )}
          </FormControl>
          <FormControl>
            <FormControl.Label>
              <Text text="Đơn vị tính" />
            </FormControl.Label>
            <TextInput
              block
              name="DVT"
              register={register}
              errors={errors}
              required={false}
              validateMessage={`Vui lòng điền nội dung miễn giảm `}
            />
          </FormControl>

          {/* Dòng 4: Áp dụng cho kỳ nộp (full width) */}
          <FormControl>
            <FormControl.Label>Áp dụng cho kỳ nộp</FormControl.Label>
            <Controller
              control={control}
              name="sf_hinhthucnopbom_ids"
              render={({ field }) => (
                <TagboxHinhThucNopBom
                  width={"100%"}
                  value={
                    field.value
                      ? field.value.split(",").map((x) => parseInt(x) || 0)
                      : []
                  }
                  onValueChanged={(values: number[]) => {
                    const sortedValues = values.sort((a, b) => {
                      return (
                        (dataObject[a] || Infinity) -
                        (dataObject[b] || Infinity)
                      );
                    });
                    field.onChange(sortedValues.join(","));
                  }}
                  dmCoSoId={dm_coso_id}
                />
              )}
            />
          </FormControl>
          <FormControl>
            <FormControl.Label>Áp dụng cho hình thức nộp</FormControl.Label>
            <Controller
              control={control}
              name="sf_saleset_register_type_id"
              render={({ field }) => (
                <CmbHinhThucNopPhi
                  width={"100%"}
                  value={field.value as number}
                  onValueChanged={(id: number, data?: any) => {
                    field.onChange(id);
                  }}
                />
              )}
            />
          </FormControl>
          <FormControl>
            <FormControl.Label>Từ ngày</FormControl.Label>
            <Controller
              control={control}
              name="tu_ngay"
              render={({ field }) => (
                <DateBox
                  width={"100%"}
                  className={"margin-right-10"}
                  value={field.value}
                  onValueChange={(value) => {
                    if (value !== null) {
                      const newNgayThu = moment(value).format("YYYY-MM-DD");
                      field.onChange(newNgayThu);
                    } else {
                      field.onChange("");
                    }
                  }}
                  displayFormat={"dd-MM-yyyy"}
                  dateSerializationFormat={"yyyy-MM-ddTHH:mm:ss"}
                  readOnly={false}
                />
              )}
            />
          </FormControl>
          <FormControl>
            <FormControl.Label>Đến ngày</FormControl.Label>
            <Controller
              control={control}
              name="den_ngay"
              render={({ field }) => (
                <DateBox
                  width={"100%"}
                  className={"margin-right-10"}
                  value={field.value}
                  onValueChange={(value) => {
                    if (value !== null) {
                      const newNgayThu = moment(value).format("YYYY-MM-DD");
                      field.onChange(newNgayThu);
                    } else {
                      field.onChange("");
                    }
                  }}
                  displayFormat={"dd-MM-yyyy"}
                  dateSerializationFormat={"yyyy-MM-ddTHH:mm:ss"}
                  readOnly={false}
                />
              )}
            />
          </FormControl>
          <FormControl>
            <FormControl.Label>Áp dụng</FormControl.Label>
            <Controller
              control={control}
              name="is_active"
              render={({ field }) => (
                <Checkbox
                  checked={field.value}
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                  }}
                />
              )}
            />
          </FormControl>
          <FormControl>
            <FormControl.Label>Áp dụng cho toàn trường</FormControl.Label>
            <Controller
              control={control}
              name="is_apdung_toantruong"
              render={({ field }) => (
                <Checkbox
                  checked={field.value}
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                  }}
                />
              )}
            />
          </FormControl>
          <FormControl sx={{ gridColumn: "1 / span 2" }}>
            <FormControl.Label>Đính kèm file</FormControl.Label>
            <Controller
              control={control}
              name="attach_files"
              render={({ field }) => (
                <FileViewAndUpload
                  accept="*"
                  files={(() => {
                    try {
                      const parsedFiles: IAttachment[] = JSON.parse(
                        field.value || "[]"
                      );
                      return parsedFiles.map((x) => ({
                        file_name: x.ten_file,
                        url: x.duong_dan,
                      }));
                    } catch (error) {
                      console.error("Lỗi khi parse attach_files:", error);
                      return [];
                    }
                  })()}
                  onValueChanged={(files) => {
                    field.onChange(
                      JSON.stringify(
                        files.map((x) => ({
                          duong_dan: x.url,
                          ten_file: x.file_name,
                          id: 0,
                        }))
                      )
                    );
                  }}
                />
              )}
            />
          </FormControl>
        </Box>
        <ModalActions>
          <Button
            text="Đóng"
            onClick={() => {
              props.onClose();
            }}
          />
          <Button text="Cập nhật" variant="primary" type="submit" />
        </ModalActions>
      </form>
    </Modal>
  );
};

export default HinhThucMienGiamEditModal;
